var map = {
	"./Kubota.jpeg": 137,
	"./Profile.jpg": 138,
	"./Vaishnavi.jpg": 72,
	"./VaishnaviCircle.jpg": 139,
	"./address_image.svg": 140,
	"./animated_logo.svg": 141,
	"./blogs_image.svg": 142,
	"./cloud_infrastructure.svg": 143,
	"./codeInLogo.png": 144,
	"./contactMail.png": 145,
	"./coursera_logo.png": 146,
	"./data_science.svg": 147,
	"./deeplearning_ai_logo.png": 148,
	"./developerActivity.svg": 149,
	"./dsc_logo.png": 150,
	"./education.svg": 151,
	"./experience.svg": 152,
	"./feelingProud.svg": 153,
	"./fullstack.svg": 154,
	"./gcp_logo.png": 155,
	"./girl.jpeg": 156,
	"./github_logo.png": 157,
	"./googleAssistant.svg": 158,
	"./google_logo.png": 159,
	"./intel_logo.jpg": 160,
	"./jsFramework.svg": 161,
	"./kwe.jpeg": 162,
	"./legato_logo.png": 163,
	"./manOnTable.svg": 164,
	"./microsoft_logo.png": 165,
	"./portfolio.gif": 166,
	"./projects_image.svg": 167,
	"./sathyabama.jpeg": 168,
	"./talksCardBack.svg": 169,
	"./talksCardBackAlt.svg": 170,
	"./ui_ux_design.svg": 171,
	"./uptycs.jpeg": 172,
	"./usc.png": 173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;